import React from 'react';
import clsx from 'clsx';
import type { CollectButtonSource } from '@soundxyz/utils/analytics';
import { MintComponent } from '@components/Song/MintComponents/MintComponent';
import { StandardModal } from '@components/main-components/modals/StandardModal';
import type { MintReferral } from '@context/mintReferral';
import { useModal } from '@context/modal';
import { CollectModalFragmentDoc, type FragmentType, getFragment, gql } from '@graphql/reactQuery';

/*#__PURE__*/ gql(/* GraphQL */ `
  fragment CollectModal on Release {
    id
    ...MintComponent
  }
`);

export const CollectModal = ({
  release,
  mintReferral,
  collectButtonSource,
}: {
  release: FragmentType<CollectModalFragmentDoc>;
  collectButtonSource: CollectButtonSource;
  mintReferral: MintReferral | null;
}) => {
  const { closeCancelModal } = useModal();
  const releaseData = getFragment(CollectModalFragmentDoc, release);

  const body = (
    <div
      className={clsx(
        "flex justify-center [&>div>div>div]:overflow-visible [&>div]:mt-0 [&>div]:w-full [&_[dir='ltr']]:p-0 [&_[role='tabpanel']]:w-[unset]",
        'mb-1',
      )}
    >
      <MintComponent
        releaseData={releaseData}
        collectButtonSource={collectButtonSource}
        referral={mintReferral}
        isInModal
      />
    </div>
  );

  return (
    <StandardModal
      body={body}
      title="Collect"
      showHeaderShadow={false}
      closeModal={closeCancelModal}
      size="small"
      bodyWithoutPaddingBottom
    />
  );
};
